<template>
  <q-list>
    <q-item-wrapper
      icon="mdi-account-tie"
      label="Who will be attending this appointment?"
      label-class="text-subtitle2"
      dense
      class="q-mb-sm invisible-item"
    />

    <!-- Staff -->
    <div class="q-px-md">
      <user-input-popover
        ref="popover"
        :model-value="event.attendees"
        outlined
        dense
        multiple
        icon="mdi-magnify"
        placeholder="Find Staff Members..."
        display="item"
        :hide-on-first-click="event.attendees.length < 1"
        :filter-func="item => can(permissions.canEditAppointments) || item.id === userData.id"
        @clicked-result="addUser"
        @removed-result="removeUser"
      >
        <template #advanced>
          <q-item-wrapper side>
            <q-btn
              v-close-popup
              icon="mdi-clock-outline"
              size="12px"
              color="blue"
              no-caps
              label="Find Available Staff"
              @click="$emit('checkAvailability')"
            />
          </q-item-wrapper>
        </template>
      </user-input-popover>
    </div>

    <MustBeStaffedBanner :event="event" class="q-ma-md" />

    <q-item-wrapper v-if="event.attendees.length > 0" side>
      <q-btn
        icon="mdi-clock-outline"
        size="12px"
        color="blue"
        no-caps
        label="Check Staff Availability"
        @click="$emit('checkAvailability')"
      />
    </q-item-wrapper>

    <!-- Staff Reminders -->
    <template v-if="event.attendees.length > 0">
      <q-separator inset spaced />

      <q-item-label
        v-if="!canAlterReminders"
        header
        class="text-red-7"
      >
        Reminders for this appointment cannot be modified
      </q-item-label>

      <q-item-wrapper>
        <q-item-label class="text-bold q-mb-sm">
          Scheduled Staff Reminders
        </q-item-label>
        <q-item-label
          v-if="event.status === 'UNSCHEDULED'"
          caption
          class="q-mb-sm text-bold text-red"
        >
          These reminders will only be sent out once this appointment is unconfirmed or scheduled.
        </q-item-label>
        <q-item-label caption class="q-my-sm">
          Choose how long before the appointment any staff members should receive a reminder
        </q-item-label>
      </q-item-wrapper>

      <EditableReminderList
        :reminders="event.staff_reminders"
        :disable="!canAlterReminders"
        :limit="STAFF_REMINDER_LIMIT"
        add-label="Add Staff Reminder"
        disable-type
        hide-row-title
        @add="addStaffReminder"
        @remove="({ value }) => removeReminder(value, event.staff_reminders)"
      />
    </template>

    <!-- Unscheduled Reminders -->
    <q-separator inset spaced />
    <q-item-wrapper>
      <q-item-label class="text-bold q-mb-sm">
        Unscheduled Reminders
      </q-item-label>
      <q-item-label
        v-if="event.status !== 'UNSCHEDULED'"
        caption
        class="q-mb-sm text-bold text-red"
      >
        These reminders will only be sent out if the appointment is unscheduled.
      </q-item-label>
      <q-item-label caption class="q-my-sm">
        Staff with administration access to the calendar can be notified to schedule this appointment as the estimated date approaches.
      </q-item-label>
    </q-item-wrapper>

    <EditableReminderList
      :reminders="event.unscheduled_reminders"
      :disable="!canAlterReminders"
      :limit="UNSCHEDULED_REMINDER_LIMIT"
      add-label="Add Unscheduled Reminder"
      disable-type
      hide-row-title
      @add="addUnscheduledReminder"
      @remove="({ value }) => removeReminder(value, event.unscheduled_reminders)"
    />
  </q-list>
</template>

<script>
import EditableReminderList from 'components/partials/communications/reminders/EditableReminderList'
import MustBeStaffedBanner from './partials/MustBeStaffedBanner'

import staffMixin from '../../mixins/staffMixin'
import { addStaffReminder, addUnscheduledReminder, STAFF_REMINDER_LIMIT, UNSCHEDULED_REMINDER_LIMIT } from 'components/app/calendar/partials/mixins/remindersMixin'

export default {
  components: {
    EditableReminderList, MustBeStaffedBanner
  },
  mixins: [staffMixin],
  props: {
    canAlterReminders: {
      type: Boolean,
      default: true
    },
    event: {
      required: true,
      type: Object
    },
    mode: {
      type: String,
      default: 'add'
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  emits: ['checkAvailability'],
  data () {
    return {
      STAFF_REMINDER_LIMIT,
      UNSCHEDULED_REMINDER_LIMIT
    }
  },
  methods: {
    addUser (val) {
      this.baseAddStaff(this.event, val, this.canAlterReminders)
    },
    removeUser (user) {
      this.baseRemoveStaff(this.event, user)
    },
    addStaffReminder () {
      addStaffReminder(this.event)
    },
    addUnscheduledReminder () {
      addUnscheduledReminder(this.event)
    },
    removeReminder (reminder, array) {
      array.splice(array.indexOf(reminder), 1)
    }
  },
  mounted () {
    if (this.event.attendees.length < 1) {
      this.timed(() => {
        if (!this.$refs.popover) {
          return
        }
        this.$refs.popover.focus()
      }, this.$q.platform.is.mobile ? 750 : 500)
    }
  }
}
</script>
